import { createSelector } from 'reselect';

const selectEvaluations = (state: any) => state.evaluations;


export const selectEvaluationsCurrentItem = createSelector([selectEvaluations], (evaluations) => evaluations.current);

export const selectEvaluationsListItems = createSelector([selectEvaluations], (evaluations) => evaluations.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectEvaluationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEvaluationsQueryItems = createSelector([selectEvaluations], (evaluations) => evaluations.query);

export const selectEvaluationsCreatedItem = createSelector([selectEvaluations], (evaluations) => evaluations.create);

export const selectEvaluationsUpdatedItem = createSelector([selectEvaluations], (evaluations) => evaluations.update);

export const selectEvaluationsReadItem = createSelector([selectEvaluations], (evaluations) => evaluations.read);

export const selectEvaluationsDeletedItem = createSelector([selectEvaluations], (evaluations) => evaluations.delete);

export const selectEvaluationsSearchedItems = createSelector([selectEvaluations], (evaluations) => evaluations.search);

export const selectEvaluationsItemsCount = createSelector([selectEvaluations], (evaluations) => evaluations.count);

export const selectEvaluationsItemsFilter = createSelector([selectEvaluations], (evaluations) => evaluations.filter);

export const selectEvaluationsSummaryItems = createSelector([selectEvaluations], (evaluations) => evaluations.summary);